/**@description Useful if you want to compare 2 arrays without care about order */
export const isEqualSets = (a: Set<string | number>, b: Set<string | number>) =>
  a.size === b.size && a.size === a.union(b).size;
